import { Link } from "react-router-dom";
import SiteVersion from "../common/SiteVersion";
const Footer = () => {
  return (
    <footer className="bg-primary-500 text-base-50 py-4 mt-auto relative z-50">
      <div className="container max-w-7xl mx-auto px-8 max-[360px]:px-4 text-center text-sm relative">
        <Link to="/changelog" className=" absolute bottom-0 right-8 max-[360px]:right-4">
          <SiteVersion className="text-base-50 text-[8px]" />
        </Link>
        <p>&copy; 2026 ChatoraHack Lottery. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;